// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from './client';
import { client } from './client.gen';
import { getMeApiV3MeGetResponseTransformer } from './transformers.gen';
import type { GetBrandHealthApiV3MetricsBrandsHealthPostData, GetBrandHealthApiV3MetricsBrandsHealthPostErrors, GetBrandHealthApiV3MetricsBrandsHealthPostResponses, GetBrandInsightsApiV3MetricsBrandsBrandIdInsightsPostData, GetBrandInsightsApiV3MetricsBrandsBrandIdInsightsPostErrors, GetBrandInsightsApiV3MetricsBrandsBrandIdInsightsPostResponses, GetBrandPostsApiV3MetricsBrandsBrandIdPostsPostData, GetBrandPostsApiV3MetricsBrandsBrandIdPostsPostErrors, GetBrandPostsApiV3MetricsBrandsBrandIdPostsPostResponses, GetBrandTabAnalysisApiV3MetricsBrandsBrandIdAnalysisTabPostData, GetBrandTabAnalysisApiV3MetricsBrandsBrandIdAnalysisTabPostErrors, GetBrandTabAnalysisApiV3MetricsBrandsBrandIdAnalysisTabPostResponses, GetConversationsApiV3ConversationsGetData, GetConversationsApiV3ConversationsGetErrors, GetConversationsApiV3ConversationsGetResponses, GetDigitalBrandMetricsApiV3MetricsBrandsDigitalPostData, GetDigitalBrandMetricsApiV3MetricsBrandsDigitalPostErrors, GetDigitalBrandMetricsApiV3MetricsBrandsDigitalPostResponses, GetFiltersApiV3MetricsFiltersGetData, GetFiltersApiV3MetricsFiltersGetErrors, GetFiltersApiV3MetricsFiltersGetResponses, GetMeApiV3MeGetData, GetMeApiV3MeGetErrors, GetMeApiV3MeGetResponses, GetMessagesApiV3ConversationsConversationIdMessagesGetData, GetMessagesApiV3ConversationsConversationIdMessagesGetErrors, GetMessagesApiV3ConversationsConversationIdMessagesGetResponses, GetPageInsightsApiV3InsightsPagePostData, GetPageInsightsApiV3InsightsPagePostErrors, GetPageInsightsApiV3InsightsPagePostResponses, GetTraditionalBrandMetricsApiV3MetricsBrandsTradPostData, GetTraditionalBrandMetricsApiV3MetricsBrandsTradPostErrors, GetTraditionalBrandMetricsApiV3MetricsBrandsTradPostResponses, PostChatMessageApiV3ChatPostData, PostChatMessageApiV3ChatPostErrors, PostChatMessageApiV3ChatPostResponses } from './types.gen';
import { zGetBrandHealthApiV3MetricsBrandsHealthPostData, zGetBrandHealthApiV3MetricsBrandsHealthPostResponse, zGetBrandInsightsApiV3MetricsBrandsBrandIdInsightsPostData, zGetBrandInsightsApiV3MetricsBrandsBrandIdInsightsPostResponse, zGetBrandPostsApiV3MetricsBrandsBrandIdPostsPostData, zGetBrandPostsApiV3MetricsBrandsBrandIdPostsPostResponse, zGetBrandTabAnalysisApiV3MetricsBrandsBrandIdAnalysisTabPostData, zGetBrandTabAnalysisApiV3MetricsBrandsBrandIdAnalysisTabPostResponse, zGetConversationsApiV3ConversationsGetData, zGetConversationsApiV3ConversationsGetResponse, zGetDigitalBrandMetricsApiV3MetricsBrandsDigitalPostData, zGetDigitalBrandMetricsApiV3MetricsBrandsDigitalPostResponse, zGetFiltersApiV3MetricsFiltersGetData, zGetFiltersApiV3MetricsFiltersGetResponse, zGetMeApiV3MeGetData, zGetMeApiV3MeGetResponse, zGetMessagesApiV3ConversationsConversationIdMessagesGetData, zGetMessagesApiV3ConversationsConversationIdMessagesGetResponse, zGetPageInsightsApiV3InsightsPagePostData, zGetPageInsightsApiV3InsightsPagePostResponse, zGetTraditionalBrandMetricsApiV3MetricsBrandsTradPostData, zGetTraditionalBrandMetricsApiV3MetricsBrandsTradPostResponse, zPostChatMessageApiV3ChatPostData, zPostChatMessageApiV3ChatPostResponse } from './zod.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * Get Me
 */
export const getMeApiV3MeGet = <ThrowOnError extends boolean = false>(options?: Options<GetMeApiV3MeGetData, ThrowOnError>) => (options?.client ?? client).get<GetMeApiV3MeGetResponses, GetMeApiV3MeGetErrors, ThrowOnError>({
    requestValidator: async (data) => await zGetMeApiV3MeGetData.parseAsync(data),
    responseTransformer: getMeApiV3MeGetResponseTransformer,
    responseType: 'json',
    responseValidator: async (data) => await zGetMeApiV3MeGetResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v3/me',
    ...options
});

/**
 * Post Chat Message
 */
export const postChatMessageApiV3ChatPost = <ThrowOnError extends boolean = false>(options: Options<PostChatMessageApiV3ChatPostData, ThrowOnError>) => (options.client ?? client).post<PostChatMessageApiV3ChatPostResponses, PostChatMessageApiV3ChatPostErrors, ThrowOnError>({
    requestValidator: async (data) => await zPostChatMessageApiV3ChatPostData.parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) => await zPostChatMessageApiV3ChatPostResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v3/chat',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Conversations
 */
export const getConversationsApiV3ConversationsGet = <ThrowOnError extends boolean = false>(options?: Options<GetConversationsApiV3ConversationsGetData, ThrowOnError>) => (options?.client ?? client).get<GetConversationsApiV3ConversationsGetResponses, GetConversationsApiV3ConversationsGetErrors, ThrowOnError>({
    requestValidator: async (data) => await zGetConversationsApiV3ConversationsGetData.parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) => await zGetConversationsApiV3ConversationsGetResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v3/conversations',
    ...options
});

/**
 * Get Messages
 */
export const getMessagesApiV3ConversationsConversationIdMessagesGet = <ThrowOnError extends boolean = false>(options: Options<GetMessagesApiV3ConversationsConversationIdMessagesGetData, ThrowOnError>) => (options.client ?? client).get<GetMessagesApiV3ConversationsConversationIdMessagesGetResponses, GetMessagesApiV3ConversationsConversationIdMessagesGetErrors, ThrowOnError>({
    requestValidator: async (data) => await zGetMessagesApiV3ConversationsConversationIdMessagesGetData.parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) => await zGetMessagesApiV3ConversationsConversationIdMessagesGetResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v3/conversations/{conversation_id}/messages',
    ...options
});

/**
 * Get Filters
 */
export const getFiltersApiV3MetricsFiltersGet = <ThrowOnError extends boolean = false>(options?: Options<GetFiltersApiV3MetricsFiltersGetData, ThrowOnError>) => (options?.client ?? client).get<GetFiltersApiV3MetricsFiltersGetResponses, GetFiltersApiV3MetricsFiltersGetErrors, ThrowOnError>({
    requestValidator: async (data) => await zGetFiltersApiV3MetricsFiltersGetData.parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) => await zGetFiltersApiV3MetricsFiltersGetResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v3/metrics/filters',
    ...options
});

/**
 * Get Traditional Brand Metrics
 */
export const getTraditionalBrandMetricsApiV3MetricsBrandsTradPost = <ThrowOnError extends boolean = false>(options: Options<GetTraditionalBrandMetricsApiV3MetricsBrandsTradPostData, ThrowOnError>) => (options.client ?? client).post<GetTraditionalBrandMetricsApiV3MetricsBrandsTradPostResponses, GetTraditionalBrandMetricsApiV3MetricsBrandsTradPostErrors, ThrowOnError>({
    requestValidator: async (data) => await zGetTraditionalBrandMetricsApiV3MetricsBrandsTradPostData.parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) => await zGetTraditionalBrandMetricsApiV3MetricsBrandsTradPostResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v3/metrics/brands/trad',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Digital Brand Metrics
 */
export const getDigitalBrandMetricsApiV3MetricsBrandsDigitalPost = <ThrowOnError extends boolean = false>(options: Options<GetDigitalBrandMetricsApiV3MetricsBrandsDigitalPostData, ThrowOnError>) => (options.client ?? client).post<GetDigitalBrandMetricsApiV3MetricsBrandsDigitalPostResponses, GetDigitalBrandMetricsApiV3MetricsBrandsDigitalPostErrors, ThrowOnError>({
    requestValidator: async (data) => await zGetDigitalBrandMetricsApiV3MetricsBrandsDigitalPostData.parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) => await zGetDigitalBrandMetricsApiV3MetricsBrandsDigitalPostResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v3/metrics/brands/digital',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Brand Health
 */
export const getBrandHealthApiV3MetricsBrandsHealthPost = <ThrowOnError extends boolean = false>(options: Options<GetBrandHealthApiV3MetricsBrandsHealthPostData, ThrowOnError>) => (options.client ?? client).post<GetBrandHealthApiV3MetricsBrandsHealthPostResponses, GetBrandHealthApiV3MetricsBrandsHealthPostErrors, ThrowOnError>({
    requestValidator: async (data) => await zGetBrandHealthApiV3MetricsBrandsHealthPostData.parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) => await zGetBrandHealthApiV3MetricsBrandsHealthPostResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v3/metrics/brands/health',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Brand Insights
 */
export const getBrandInsightsApiV3MetricsBrandsBrandIdInsightsPost = <ThrowOnError extends boolean = false>(options: Options<GetBrandInsightsApiV3MetricsBrandsBrandIdInsightsPostData, ThrowOnError>) => (options.client ?? client).post<GetBrandInsightsApiV3MetricsBrandsBrandIdInsightsPostResponses, GetBrandInsightsApiV3MetricsBrandsBrandIdInsightsPostErrors, ThrowOnError>({
    requestValidator: async (data) => await zGetBrandInsightsApiV3MetricsBrandsBrandIdInsightsPostData.parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) => await zGetBrandInsightsApiV3MetricsBrandsBrandIdInsightsPostResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v3/metrics/brands/{brand_id}/insights',
    ...options
});

/**
 * Get Brand Tab Analysis
 */
export const getBrandTabAnalysisApiV3MetricsBrandsBrandIdAnalysisTabPost = <ThrowOnError extends boolean = false>(options: Options<GetBrandTabAnalysisApiV3MetricsBrandsBrandIdAnalysisTabPostData, ThrowOnError>) => (options.client ?? client).post<GetBrandTabAnalysisApiV3MetricsBrandsBrandIdAnalysisTabPostResponses, GetBrandTabAnalysisApiV3MetricsBrandsBrandIdAnalysisTabPostErrors, ThrowOnError>({
    requestValidator: async (data) => await zGetBrandTabAnalysisApiV3MetricsBrandsBrandIdAnalysisTabPostData.parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) => await zGetBrandTabAnalysisApiV3MetricsBrandsBrandIdAnalysisTabPostResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v3/metrics/brands/{brand_id}/analysis/{tab}',
    ...options
});

/**
 * Get Brand Posts
 */
export const getBrandPostsApiV3MetricsBrandsBrandIdPostsPost = <ThrowOnError extends boolean = false>(options: Options<GetBrandPostsApiV3MetricsBrandsBrandIdPostsPostData, ThrowOnError>) => (options.client ?? client).post<GetBrandPostsApiV3MetricsBrandsBrandIdPostsPostResponses, GetBrandPostsApiV3MetricsBrandsBrandIdPostsPostErrors, ThrowOnError>({
    requestValidator: async (data) => await zGetBrandPostsApiV3MetricsBrandsBrandIdPostsPostData.parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) => await zGetBrandPostsApiV3MetricsBrandsBrandIdPostsPostResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v3/metrics/brands/{brand_id}/posts',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Page Insights
 */
export const getPageInsightsApiV3InsightsPagePost = <ThrowOnError extends boolean = false>(options: Options<GetPageInsightsApiV3InsightsPagePostData, ThrowOnError>) => (options.client ?? client).post<GetPageInsightsApiV3InsightsPagePostResponses, GetPageInsightsApiV3InsightsPagePostErrors, ThrowOnError>({
    requestValidator: async (data) => await zGetPageInsightsApiV3InsightsPagePostData.parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) => await zGetPageInsightsApiV3InsightsPagePostResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v3/insights/{page}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
